import React from 'react';

import { WorkoutCalculatedMetricDefinitionDto } from '@api/FitnessActivityClient';
import { ConfirmationModal } from '@components/confirmation-modal';
import { Api } from '@core/api';
import { toast } from '@core/toast';
import { injectTSDI } from '@core/tsdi';

interface Props {
    definition: WorkoutCalculatedMetricDefinitionDto | null;
    onClose(): void;
    onSuccess(): void;
}

export function DeleteCalculatedMetricDefinitionDialog({
    definition,
    onClose,
    onSuccess
}: Props) {
    const { fitnessActivityClient } = injectTSDI(Api);

    const handleDelete = async () => {
        if (!definition) {
            return false;
        }
        await fitnessActivityClient.admin.workoutCalculatedMetricDefinitionControllerDelete(
            definition.id
        );
        toast.success('Calculated metric deleted');
        onSuccess();
        return false;
    };

    return (
        <ConfirmationModal
            open={Boolean(definition)}
            title="Delete Calculated Metric"
            buttonText="Delete"
            destructive
            onModalClose={onClose}
            submitHandler={handleDelete}
        >
            <p className="text-sm">
                Are you sure you want to delete &quot;
                {definition?.metricKey}&quot;? Workouts processed from now on
                will no longer carry this metric. This action cannot be undone.
            </p>
        </ConfirmationModal>
    );
}
